import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/alibaba/iconfont.css'

Vue.use(ElementUI);
// Vue.config.productionTip = false
router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
    if(sessionStorage.getItem('token')!=='undefined' && sessionStorage.getItem('token')!==null){ //判断本地是否存在token
      // store.dispatch("login",sessionStorage.getItem('username'));
      next();
    }else {
      next({
        path:'/'
      })
    }
  }
  else {
    next();
  }
  /*如果本地 存在 token 则 不允许直接跳转到 登录页面*/
 
});
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
